import { Link } from 'react-router-dom';

const footerLinks = {
  快速导航: [
    { label: '首页', to: '/' },
    { label: '分类浏览', to: '/category/all' },
    { label: '关于我们', to: '/about' },
  ],
  热门分类: [
    { label: '香蕉视频', to: '/category/xiangjiao' },
    { label: '红桃视频', to: '/category/hongtao' },
    { label: '91视频', to: '/category/91shipin' },
    { label: '蜜桃视频', to: '/category/mitao' },
  ],
  更多平台: [
    { label: '樱花视频', to: '/category/yinghua' },
    { label: '糖豆视频', to: '/category/tangdou' },
    { label: '樱桃视频', to: '/category/yingtao' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-circle-fill text-background-50 text-xl"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">青青草视频</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              聚合香蕉视频、红桃视频、91视频、蜜桃视频等热门影视平台，为您提供一站式高清免费在线观看体验。
            </p>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">{title}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 青青草视频 版权所有 | 本站内容仅供学习交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-primary-400 transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}